if ( objects.is_front_page || objects.is_template_front_page ) {
    const elements = document.querySelectorAll(".tommy-co-text");
    var timelineTextLogo = gsap.timeline();
    timelineTextLogo.set(elements, { autoAlpha: 0 });
    timelineTextLogo
        .from(elements, {
        autoAlpha:0,
        duration: 1,
        stagger: 0.2,
        drawSVG: "0% ",
        })

        timelineTextLogo.pause();

    ScrollTrigger.create({
        trigger: "#tommyco-presentation",
        onEnter: () => timelineTextLogo.play(),
        onLeaveBack: () => timelineTextLogo.reverse(),
        start: "top center", 
        end: "bottom center", 
        // markers: true
    });
}